import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from '@/providers/RouterShim';
import type { LeadSearchResponse } from '../../../@types/CrossDomainSearch';
import type { RequestStateQuery } from '../../../@types/RequestStateQuery';
import { getJSON } from '../../../fetch';
import useAuth from '../../../hooks/useAuth';

const getCdsLeadsQuery = () => {
  const crossDomainSearchUri = process.env.NEXT_PUBLIC_CROSS_DOMAIN_SEARCH_URI;
  return `${crossDomainSearchUri}/cross-domain-search/explore/:branchId/leads`;
};

export const CDS_LEADS_QUERY = getCdsLeadsQuery();

interface UseLeadsOptions {
  overrideSearchParams?: URLSearchParams;
}

const useLeads = (
  options?: UseLeadsOptions,
): [LeadSearchResponse | undefined, RequestStateQuery] => {
  const { branchId } = useParams();
  const { getToken } = useAuth();
  const [searchParams] = !options?.overrideSearchParams
    ? useSearchParams()
    : [options.overrideSearchParams];

  const { data, isPending, isSuccess, isError } = useQuery<LeadSearchResponse>({
    queryKey: [
      CDS_LEADS_QUERY,
      branchId,
      { search: searchParams.toString(), bypass: !!options?.overrideSearchParams },
    ],
    queryFn: async () => {
      const url = new URL(CDS_LEADS_QUERY.replace(':branchId', branchId!));
      url.search = searchParams.toString();
      const response = await getJSON<LeadSearchResponse>(url.toString(), getToken()!);
      return response;
    },
    enabled: !!branchId,
  });
  return [data, { isLoading: isPending, isSuccess, isError }];
};

export default useLeads;
